import React from 'react';
import { RegisterForm } from './RegisterForm';


export const RegisterPage = () => {
    return (
        < RegisterForm />
    )
}